import { paymentService } from './paymentService'

/**
 * The payment module façade. No store: the plan and the invoice list are re-fetched by the settings
 * pages that show them, and nothing else in the app reads billing state.
 */
export const usePayment = () => {
  return {
    payment: {
      service: paymentService()
    }
  }
}
